import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  initiateNewTransaction,
  resetPaymentMethod,
  selectCashierConfiguration,
  selectPaymentCurrentState,
  selectPaymentFormPayload,
  selectPaymentFormSchema,
  selectPaymentMethod,
  selectProcessingResultAction,
  selectRegistrationResultAction,
} from '@cashier/cashier-data-access';
import { useUIConfiguration } from '@cashier/cashier-shared';

import {
  PaymentResultConfiguration,
  PaymentResultConfigurator,
} from '../utils/paymentResultConfiguration';

export const usePaymentResult = (): PaymentResultConfiguration => {
  const processingResultAction = useSelector(selectProcessingResultAction);
  const registrationResultAction = useSelector(selectRegistrationResultAction);
  const paymentMethod = useSelector(selectPaymentMethod);

  const formPayload = useSelector(selectPaymentFormPayload);
  const formSchema = useSelector(selectPaymentFormSchema);

  const { currency, paymentType } = useSelector(selectCashierConfiguration);
  const paymentCurrentState = useSelector(selectPaymentCurrentState);

  const completionBehaviour = useUIConfiguration(
    'paymentResult',
    'completionBehaviour',
  );

  const { final_screen_description } = paymentMethod || {};
  const amountField = formSchema?.staticData.amount || null;

  const dispatch = useDispatch();

  const onButtonClick = useCallback(() => {
    dispatch(initiateNewTransaction());
    dispatch(resetPaymentMethod());
  }, [dispatch]);

  return PaymentResultConfigurator.configure({
    resultAction: registrationResultAction || processingResultAction || null,
    completionBehaviour,
    paymentType,
    paymentState: paymentCurrentState,
    amount: amountField
      ? ((formPayload[amountField.name]?.value || '') as string)
      : '',
    currency: currency || '',
    paymentMethodMessage: final_screen_description || null,
    onButtonClick,
  });
};
